import React, { useState } from "react";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import "./imageCarousel.scss";

const ImageCarousel = ({carouselData}) => {
  const [slide, setSlide] = useState(0);

  const nextSlide = () => {
    setSlide(slide === carouselData.length - 1 ? 0 : slide + 1);
  };

  const prevSlide = () => {
    setSlide(slide === 0 ? carouselData.length - 1 : slide - 1);
  };
console.log('carouselData................',carouselData)
  return (
    <div className="carousel">
      <ArrowCircleLeftIcon onClick={prevSlide} className="arrow arrow-left" />
      {carouselData?.map((item, idx) => {
        return (
          <img
            src={`data:image/jpeg;base64,${item}`}
            alt='image'
            key={idx}
            className={slide === idx ? "slide" : "slide slide-hidden"}
          />
        );
      })}
      <ArrowCircleRightIcon onClick={nextSlide} className="arrow arrow-right" />
      <span className="indicators">
        {carouselData?.map((_, idx) => {
          return (
            <button
              key={idx}
              className={
                slide === idx ? "indicator" : "indicator indicator-inactive"
              }
              onClick={() => setSlide(idx)}
            ></button>
          );
        })}
      </span>
    </div>
  );
};
export default ImageCarousel;
